import { render, staticRenderFns } from "./writer.vue?vue&type=template&id=70cf9610&"
import script from "./writer.vue?vue&type=script&lang=js&"
export * from "./writer.vue?vue&type=script&lang=js&"
import style0 from "./writer.vue?vue&type=style&index=0&id=70cf9610&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports